/**
 * Gets the value stored under the given key in document.cookie
 *
 * ```js
 * import { readCookie } from '@minerva-analytics/pantheon';
 *
 * value = readCookie(`cookieKey`)
 * ```
 *
 * @param  {string} key The key of the cookie
 * @return {string} The value of the cookie
 *
 */
var readCookie = function readCookie(key) {
  if (typeof document === 'undefined' || !key) {
    return "";
  }

  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
};

export default readCookie;